import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { fetchArticlesAuthoredBy } from "../actions/articleActions";
import Articles from "../pages/Articles";
import withFetchErrorHandler from "../Hocs/withFetchErrorHandler";
const WithFetchErrorHandlerArticles = withFetchErrorHandler(Articles);
const Account = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const [articles, setArticles] = useState();
  console.log(id);
  const user = useSelector((state) => state.session);
  const logout = () => {
    history.push("/login");
    dispatch({ type: "LOGOUT" });
  };
  useEffect(() => {
    (async function getArticlesAuthoredBy() {
      const data = await fetchArticlesAuthoredBy(id);
      setArticles(data);
    })();
    //eslint-disable-next-line
  }, []);

  return (
    <div className="widthContainer">
      <div className="user-profile">
        <div className="user">
          <h1>{`${jwtDecode(user?.accessToken)
            .name.split(" ")[0]
            .substr(0, 1)}${jwtDecode(user?.accessToken)
            .name.split(" ")[1]
            .charAt(0)}`}</h1>
        </div>
        <div className="user-details">
          <h2>{`${jwtDecode(user?.accessToken).name}`}</h2>
          <p>{`${jwtDecode(user?.accessToken).email}`}</p>
        </div>
        <button className="logout-btn" onClick={() => logout()}>
          Sign out
        </button>
      </div>
      <div className="authored-articles-container">
        <h3>Authored</h3>
        <WithFetchErrorHandlerArticles
          articles={articles}
          message="Publish your own article now!"
          owner={true}
        />
      </div>
    </div>
  );
};

export default Account;
